/**
 * إغلاق شاشة الطباعة — من داخل طبقة المعاينة أو من تبويبٍ مستقل.
 *
 * `window.close()` لا يفعل شيئًا داخل إطارٍ داخلي: المتصفح لا يسمح لصفحةٍ
 * بإغلاق نافذةٍ لم تفتحها هي. وصفحة الطباعة تُعرض في الحالتين — داخل
 * `DocPreview` وفي تبويبٍ مستقل — فكان زرّ «إغلاق» يعمل في حالةٍ ويصمت في
 * الأخرى، ولا شيء يشرح للمستخدم لماذا.
 *
 * فهنا تُميَّز الحالتان: داخل إطارٍ تُرسَل رسالةٌ إلى الحاوية لتغلق الطبقة،
 * وخارجه يُغلق التبويب كما كان.
 */
export const PRINT_CLOSE_MESSAGE = 'goyone:print-close';

export function closePrintView(): void {
  const embedded = window.parent !== window;

  if (embedded) {
    window.parent.postMessage(PRINT_CLOSE_MESSAGE, window.location.origin);
    return;
  }

  window.close();
}
